import React from "react";

const CatalogueShimmer = () => {
  return (
    <div className="flex items-center justify-center min-h-screen w-full bg-gray-100">
      <div className="flex gap-2 w-11/12 md:w-3/4 lg:w-2/3 h-72 md:h-[28rem]">
        {/* Left Page Shimmer */}
        <div className="flex-1 bg-gray-300 rounded-lg animate-pulse"></div>
        {/* Right Page Shimmer */}
        <div className="flex-1 bg-gray-300 rounded-lg animate-pulse"></div>
      </div>
    </div>
  );
};

export default CatalogueShimmer;
